<template>
  <div class="logout">
  </div>
</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/auth'

  export default {
    name: 'Logout',
    mounted() {
      firebase.auth().signOut().then(() => {
        this.$router.push('/login')
      }).catch(error => {
        alert(error)
      });
    }
  }
</script>